module.exports = __webpack_public_path__ + "static/media/item_17_7_comp.6d7487ec.png";